import type { FC } from "react";
import PropTypes from "prop-types";
import type { Theme } from "@mui/material";
import { Box, useMediaQuery } from "@mui/material";

const TOP_NAV_HEIGHT: number = 64;
const SIDE_NAV_WIDTH: number = 280;

interface TopNavProps {
  onMobileNavOpen?: () => void;
}

export const TopNav: FC<TopNavProps> = (props) => {
  const { onMobileNavOpen, ...other } = props;
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  return <Box></Box>;
};

TopNav.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
